import { linkifyText } from './linkifyText';

export function isHTML(inputString: string) {
  const htmlRegex = /<\s*[a-z][^>]*>/i;
  return htmlRegex.test(inputString);
}

export function linkifyHTMLString(html: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const recursiveMap = (element: Element): Element => {
    if (element.tagName && element.tagName.toLowerCase() === 'a') {
      return element;
    }

    if (element.nodeType === Node.TEXT_NODE) {
      const linkifiedHtml = linkifyText(element.textContent || '');
      const newElement = document.createElement('span');
      newElement.innerHTML = linkifiedHtml;

      return newElement;
    }

    if (element?.childNodes?.length) {
      const childNodes = Array.from(element.childNodes) as Element[];
      const newChildNodes = childNodes.map(recursiveMap);
      element.replaceChildren(...newChildNodes);
    }

    return element;
  };

  const newBody = recursiveMap(doc.body);
  return newBody.innerHTML;
}
